import { Injectable } from "@angular/core";
import { TramiteStatusService } from "./tramite-status.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tramiteStatusLoadFailure, tramiteStatusLoadRequest, tramiteStatusLoadSuccess } from "./tramite-status.actions";
import { environment } from "projects/registro-personas-empresas/src/environments/environment";
import { catchError, map, mergeMap } from "rxjs/operators";
import { of } from "rxjs";

@Injectable()
export class TramiteStatusEffect {
  constructor(
    private actions$: Actions,
    private tramiteStatusService: TramiteStatusService
  ) {
    this.tramiteStatusService.url = environment.apiUrl;
  }

  loadRequestTramiteStatus = createEffect(() =>
    this.actions$.pipe(
      ofType(tramiteStatusLoadRequest),
      mergeMap(() =>
        this.tramiteStatusService.getTramiteStatus().pipe(
          map((items) => tramiteStatusLoadSuccess({ items })),
          catchError((error) => of(tramiteStatusLoadFailure({ error })))
        )
      )
    )
  )

  loadSuccessTramiteStatus = createEffect(() =>
    this.actions$.pipe(
      ofType(tramiteStatusLoadSuccess),
    ), { dispatch: false }
  )
}
